import { ContactPage } from '@/features/entrypoint/components/ContactPage'
import { RouteName } from '@shared/constants/routes'
import { createServerSidePropsHandler } from '@/features/shared/serverUtils/ssrHelpers/createServerSidePropsHandler'
import { fetchCMSDataForSSR } from '@/features/cms/services/CMS/serverUtils'
import { withoutHeaderLayout } from '@/features/shared/components/Headers/Layouts/withoutHeaderLayout'

export const getServerSideProps = createServerSidePropsHandler(
  RouteName.CONTACT,
  fetchCMSDataForSSR,
)

// header is controlled via CMS
export default withoutHeaderLayout(ContactPage)
